import React from 'react'
import { useAuth } from '@hpanel/web-common/contexts/AuthContext'
import { ChangePasswordForm } from '@hpanel/web-common/components/ChangePasswordForm'
import { TwoFactorSetup } from '@hpanel/web-common/components/TwoFactorSetup'

/**
 * Tenant Account page: sign-in security for the current user.
 *
 * Until 2026-10 a tenant had no way to change their own password or enroll
 * in 2FA from the panel — both lived only in the admin console.
 */
export const Account: React.FC = () => {
  const { user } = useAuth()
  return (
    <div data-testid="account-page" className="space-y-6 max-w-3xl">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">Account</h1>
        <p className="text-gray-600 dark:text-gray-400 mt-1">
          Signed in as <strong>{user?.username}</strong>
          {user?.email ? ` (${user.email})` : ''}. Your panel password is also your SFTP password.
        </p>
      </div>
      <ChangePasswordForm />
      <TwoFactorSetup />
    </div>
  )
}
